<template>
  <keep-alive>
    <router-view/>
  </keep-alive>
</template>

<style lang="scss">
*{
  margin: 0;
  padding: 0;
}
  body{
/*overflow-x: hidden;*/
  }
</style>
